import { render, staticRenderFns } from "./DxItem.vue?vue&type=template&id=0a78963c"
import script from "./DxItem.vue?vue&type=script&lang=js"
export * from "./DxItem.vue?vue&type=script&lang=js"
import style0 from "./DxItem.vue?vue&type=style&index=0&id=0a78963c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports